<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <form id="createInstructor" @submit="createInstructor" >
          <CCardHeader>
            <CCol col="6" style="font-size: 25px;">إضافة مدرب جديد</CCol>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="6">
                <CInput label="English Name"
                  id="full_name"
                  v-model="instructor.full_name"
                  class="required"
                  placeholder=" أدخل إسم المدرب بالانجليزية"
                  :invalidFeedback="errors.full_name"
                  required
                />
              </CCol>
              <CCol sm="6">
                <CInput label="الاسم"
                  id="full_name"
                  v-model="instructor.full_name_ar"
                  class="required"
                  placeholder="أدخل إسم المدرب بالعربي"
                  :invalidFeedback="errors.full_name_ar"
                  required
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="6">
                <CInput label="البريد الإلكتروني"
                type="email"
                  id="email"
                  v-model="instructor.email"
                  class="required"
                    pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  placeholder="ادخل البريد الإلكتروني "
                  :invalidFeedback="errors.email"
                  required
                />
              </CCol>
            </CRow>
            <br>
             <CRow>
               <CCol col="6">
                <div class='form-group'>
                  <label for='image' >
                    اضافة صوره شخصيه
                    <span class='star'>*</span>
                  </label>
                  <input type="file" class="form-control"
                    id="image"
                    v-on:change="onFileChange"
                  >
                  </div>
               </CCol>
            </CRow>
            <br>
             <CRow>
              <CCol col="12">
                <label>نبذه شخصيه بالانجليزية</label>
              </CCol>
              <CCol col="8">
                  <VueEditor v-model='instructor.description' :invalidFeedback="errors.description" />
              </CCol>
            </CRow>
            <br>
             <CRow>
              <CCol col="12">
                <label>نبذه شخصيه بالعربي</label>
              </CCol>
              <CCol col="8">
                  <VueEditor v-model='instructor.description_ar' :invalidFeedback="errors.description_ar" />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton type="submit" size="sm" color="primary" ><CIcon name="cil-check-circle"/> حفظ</CButton>
              &emsp;
            <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> مسح </CButton>
          </CCardFooter>
          </form>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { VueEditor } from 'vue2-editor'
export default {
  name: 'CreateInstructor',
  components: {
    VueEditor
  },
  data: function () {
    return {
      instructor: {},
      errors: [],
      image: ''
    }
  },
  methods: {
    onFileChange (e) {
      const _URL = window.URL || window.webkitURL
      this.image = e.target.files[0]
      let file = ''
      if ((file = e.target.files[0])) {
        const img = new Image()
        img.src = _URL.createObjectURL(file)
      }
    },
    async createInstructor (e) {
      e.preventDefault()
      const regexemail = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/
      const formData = new FormData()
      if (/^\d+$/.test(this.instructor.full_name)) {
        swal('اسم المدرب يجب ان يحتوي على حروف')
        return 0
      }
      if (/^\d+$/.test(this.instructor.full_name_ar)) {
        swal('اسم المدرب يجب ان يحتوي على حروف')
        return 0
      }
      if (!this.instructor.email.match(regexemail)) {
        swal('ادخل ايميل صحيح')
        return 0
      }

      document.querySelector('#email').setAttribute('type', 'email')
      formData.append('full_name', this.instructor.full_name)
      formData.append('full_name_ar', this.instructor.full_name_ar)
      formData.append('email', this.instructor.email)
      if (this.image) {
        formData.append('image', this.image)
      }
      if (this.instructor.description) {
        formData.append('description', this.instructor.description)
      }
      if (this.instructor.description_ar) {
        formData.append('description_ar', this.instructor.description_ar)
      }
      this.errors = await this.postRequest(formData, this.$hostUrl + 'instructors', '/instructors')
    }
  }
}

</script>
